import { useRouter } from 'next/router';
import styled from 'styled-components';
import useWindowSize from 'beek-design-system/utils/useWindowSize';

import FooterDesktop from './FooterDesktop';
import FooterMobile from './FooterMobile';

type FooterProps = {
  marginTopDesktop?: string;
  marginTopMobile?: string;
};

const defaultProps = {
  marginTopMobile: '0rem',
  marginTopDesktop: '0rem',
};

const FooterDesktopContainer = styled.footer<FooterProps>`
  width: 100%;
  background: var(--snow-blue);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: ${(props): string | undefined => props.marginTopDesktop};
  padding: 2rem 1rem 2rem 1rem;
  height: 100%;
  box-sizing: border-box;
`;

const FooterMobileContainer = styled.footer<FooterProps>`
  background-color: var(--snow-blue);
  width: 100%;
  height: 100%;
  padding: 2rem 1rem;
  margin-top: ${(props): string | undefined => props.marginTopMobile};
`;

const Footer = ({
  marginTopDesktop,
  marginTopMobile,
}: FooterProps): JSX.Element => {
  const screenSize = useWindowSize();
  const router = useRouter();
  let isDesktop = false;
  if (screenSize.width != null) isDesktop = screenSize.width >= 1024;

  const changeLanguage = (locale: string): void => {
    router.push(router.asPath, {}, { locale });
  };

  const getLanguage = (): string | undefined => router.locale;

  if (isDesktop) {
    return (
      <FooterDesktopContainer marginTopDesktop={marginTopDesktop}>
        <FooterDesktop
          changeLanguage={changeLanguage}
          getLanguage={getLanguage}
        />
      </FooterDesktopContainer>
    );
  }
  return (
    <FooterMobileContainer marginTopMobile={marginTopMobile}>
      <FooterMobile changeLanguage={changeLanguage} getLanguage={getLanguage} />
    </FooterMobileContainer>
  );
};

Footer.defaultProps = defaultProps;

export default Footer;
